<template>
    <div class="search-result layout-sub-page">
        <!-- 1. 导航栏 -->
        <div class="title-bar dsp-flex">
            <div class="title-side title-gray">
                <i class="iconfont icon-xiangzuo" @click="clickBack()"></i>
            </div>
            <div class="title-middle">搜索结果</div>
        </div>

        <!-- 2. 标题栏 -->
        <div class="search-result-title dsp-flex">
            <!-- 分组名和选择部分：布局需要固定宽度 -->
            <div v-if="searchResultFromPage == 'search'" class="search-result-title-half">
                <span>条件:</span>
                <span>{{searchList[searchSelectedData.situation - 1]}}</span>
                <span>{{searchSelectedData.sex == -1 ? '' : sexList[searchSelectedData.sex]}}</span>
                <span>年龄{{searchSelectedData.age == 0 ? '升序' : '降序'}}</span>
            </div>
            <!--  -->
            <div @click="clickLabel" v-if="searchResultFromPage == 'label'" class="search-result-title-half">
                <span>标签:</span>
                <span>{{searchedLabelString}}</span>
                <!-- <span v-for="label in searchedLabelData" v-bind:key="label.id">{{label.f_title}}</span> -->
            </div>
            
            <!-- 年月日时部分 -->
            <div class="layout-glt-note">
                <span>年</span>
                <span>月</span>
                <span>日</span>
                <span>时</span>
            </div>
        </div>

        <!-- 3. 列表数据 -->
        <div v-show="searchResultList.length > 0"  class="search-result-result-list">
            <virtual-list id="SearchResultList" class="overflow-y-scroll scroll-touch"
                :data-key="'id'"
                :data-sources="searchResultList"
                :data-component="itemComponent"
                :estimate-size="50"
                :item-class="'com-record-item-w90'" />
        </div>
        
        <!-- 4. 所有标签弹框 -->
        <van-popup class="search-result-label-pop" v-bind:value="showLabelPop" @click-overlay='clickLabelPopOverlay'>
            <div class="search-result-label-title">所有标签</div>
            <div class="search-result-label-list">
                <span v-for="label in searchedLabelData" v-bind:key="label.id" class="search-result-label-item">{{label.f_title}}</span>
            </div>
        </van-popup>
    </div>
</template>

<script>
import SearchResultRItem from '../../components/search/SearchResultRItem.vue'
import { SEARCH_DOM } from '../../modules/dom';
export default {
    name: 'SearchResult',
    computed: {
        searchSelectedData() {
            return this.$store.state.search.searchSelectedData;
        },
        searchResultList() {
            return this.$store.state.search.searchResultList;
        },
        searchResultFromPage() {
            return this.$store.state.search.searchResultFromPage;
        },
        searchedLabelString() {
            return this.$store.state.label.searchedLabelString;
        },
        searchedLabelData() {
            return this.$store.state.label.searchedLabelData;
        }
    },
    data(){
        return {
            searchList: ['印重','命旺','伤官','财旺','煞重'],
            sexList: ['男', '女'],
            showLabelPop: false,
            itemComponent: SearchResultRItem
        }
    },
    mounted: function() {
        this.$el.style = 'width: '+ window.innerWidth + 'px; height: ' + window.innerHeight + 'px';
        this.$el.style.overflow = 'hidden';

        var topDiv = document.getElementsByClassName('title-bar')[0];
        var titleDiv = document.getElementsByClassName('search-result-title')[0];
        titleDiv.style.paddingTop = topDiv.clientHeight + 'px';
        var listDiv = document.getElementsByClassName('search-result-result-list')[0];
        listDiv.style.paddingTop = 0;
        listDiv.style.height = (innerHeight - titleDiv.clientHeight) + 'px';
        listDiv.style.overflow = 'hidden';
        var resultList = document.getElementById('SearchResultList');
        resultList.style.height = (innerHeight - titleDiv.clientHeight) + 'px';
    },
    methods: {
        clickBack() {
            var fromPage = this.$store.state.search.searchResultFromPage;
            SEARCH_DOM.updateSearchPageStyle();
            if(fromPage == 'search') {
                this.$router.replace('/search');
            }else if(fromPage == 'label') {
                this.$store.state.label.selectedLabelData = this.$store.state.label.searchedLabelData;
                this.$store.state.label.confirmedLabelData = this.$store.state.label.searchedLabelData;
                this.$router.replace('/search/label');
            }else {
                this.$router.replace('/search');
            }
            this.$store.dispatch('search/resetData');
        },
        clickLabel() {
            this.showLabelPop = true;
        },
        clickLabelPopOverlay() {
            this.showLabelPop = false;
        }
    }
}
</script>